<form class="form" [formGroup]="freightForm" (ngSubmit)="onSubmit()">
  <div class="container">
    <div class="freightBasicContainer">
      <div class="containerRow">
        @if (!isOrder) {
          <gl-checkbox
            class="checkbox"
            [defaultChecked]="true"
            formControlName="publish"
            >{{ 'publish' | translate }}
            <gl-modal-hint class="info" (click)="preventClick($event)">
              <p>
                {{ 'publish_on_trans_info' | translate }}
              </p>
            </gl-modal-hint>
          </gl-checkbox>
        }
        <ng-container formGroupName="requirements">
          <gl-checkbox
            class="checkbox"
            formControlName="is_ftl"
            >{{ 'FTL' | translate }}
          </gl-checkbox>
          <gl-select formControlName="required_truck_bodies" placeholder="body_type" class="select" [isLong]="true" [defaultValue]="getFirstCheckedBody()">
            @for (body of requiredTrackBodies; track body; let i = $index) {
              <gl-option
                [value]="body.value"
                [label]="body.label"
                [loadType]="true"
                class="selectOption"
                >
                <gl-checkbox
                  [ngModel]="checkboxes[i]"
                  [defaultChecked]="checkboxes[i]"
                  (ngModelChange)="setRequiredTrucks(body)"
                  [ngModelOptions]="{ standalone: true }"
                  >
                  {{ body.label }}
                </gl-checkbox>
              </gl-option>
            }
          </gl-select>
        </ng-container>
        <gl-select formControlName="vehicle_size" placeholder="vehicle_size" class="select" [isLong]="true" [defaultValue]="getFirstCheckedVehicle()">
          @for (body of vehicleSizes; track body; let i = $index) {
            <gl-option
              [value]="body.value"
              [label]="body.label"
              [loadType]="true"
              class="selectOption"
              >
              <gl-checkbox
                [ngModel]="vehiclesCheckboxes[i]"
                [defaultChecked]="vehiclesCheckboxes[i]"
                (ngModelChange)="setVehicleSize(body)"
                [ngModelOptions]="{ standalone: true }"
                >
                {{ body.label }}
              </gl-checkbox>
            </gl-option>
          }
        </gl-select>
        <gl-input-container class="input" [ngClass]="{'disabledInput': isDisabled}" units="weightT">
          <input
            type="number"
            normal-input
            min="0"
            placeholder="capacity"
            formControlName="capacity"
            />
        </gl-input-container>
        <gl-input-container class="input" [ngClass]="{'disabledInput': isDisabled}">
          <input
            type="number"
            normal-input
            min="0"
            placeholder="LDM"
            formControlName="ldm"
            />
        </gl-input-container>
      </div>
      <div class="containerRow">
        @if (isOrder) {
          <ng-container formGroupName="payment">
            <gl-input-container class="input">
              <input
                type="number"
                min="0"
                normal-input
                placeholder="days"
                formControlName="days"
                />
            </gl-input-container>
            <ng-container formGroupName="price">
              <gl-select formControlName="type" class="select" placeholder="type">
                <gl-option label="km" value="km"></gl-option>
                <gl-option label="route" value="route"></gl-option>
              </gl-select>
              <gl-input-container class="input">
                <input
                  type="number"
                  min="0"
                  normal-input
                  placeholder="price"
                  formControlName="value"
                  />
              </gl-input-container>
              <gl-select formControlName="currency" class="select" placeholder="currency">
                @for (currency of currencies; track currency) {
                  <gl-option [label]="currency.label"
                  [value]="currency.value"></gl-option>
                }
              </gl-select>
            </ng-container>
          </ng-container>
        }
        @if (isOrder) {
          <ng-container formGroupName="monitoring">
            <gl-checkbox
              class="checkbox"
              formControlName="required"
              >{{ 'monitoring_required' | translate }}
            </gl-checkbox>
          </ng-container>
        }
      </div>
    </div>
    <div formArrayName="spots" class="spotsContainer">
      @for (spot of spots?.controls; track spot; let i = $index) {
        <div [formGroupName]="i" class="spotContainer">
          <div class="headerContainer">
            @if (isMultiStop) {
              <h2 class="spotTitle">{{ 'spot' | translate }} {{ i + 1 }}</h2>
            }
            @if (!isMultiStop && i === 0) {
              <h2 class="spotTitle">{{ 'loading' | translate }}</h2>
            }
            @if (!isMultiStop && i === 1) {
              <h2 class="spotTitle">{{ 'unloading' | translate }}</h2>
            }
          </div>
          <div formGroupName="place" class="placeContainer">
            <div formGroupName="address" class="addressContainer">
              <gl-select
                class="select"
                placeholder="country"
                formControlName="country"
                [searchOption]="true"
                (searchEmit)="onSearch($event)"
                >
                @for (country of countries; track country) {
                  <gl-option [value]="country.code" [label]="country.name">
                  </gl-option>
                }
              </gl-select>
              <gl-input-container class="input">
                <input
                  type="text"
                  normal-input
                  placeholder="location"
                  formControlName="locality"
                  />
              </gl-input-container>
              <gl-input-container class="input">
                <input
                  type="text"
                  normal-input
                  placeholder="postal_code"
                  formControlName="postal_code"
                  />
              </gl-input-container>
            </div>
          </div>
          <div formArrayName="operations" class="operationsContainer">
            @for (operation of getOperationControls(spot); track operation; let ii = $index) {
              <div [formGroupName]="ii"
                class="operationContainer">
                <div class="headerContainer">
                  <h2 class="operationTitle">{{ 'operation' | translate }}
                    @if (isMultiStop) {
                      {{ ii + 1 }}
                    }
                  </h2>
                </div>
                <div class="containerRow">
                  <gl-select
                    class="select type"
                    placeholder="type"
                    formControlName="type"
                    [ngClass]="{'disabledInput': isDisabled}"
                    >
                    <gl-option label="{{'loading' | translate}}" value="loading"></gl-option>
                    <gl-option label="{{'unloading' | translate}}" value="unloading">
                    </gl-option>
                  </gl-select>
                  <ng-container formArrayName="loads">
                    <gl-select class="select" placeholder="loads" [formControl]="getLoadsSelectControl(operation)"
                      [ngClass]="{'disabledLoads': isDisabled}" [isLong]="true">
                      @for (group of getLoadControls(operation); track group) {
                        <gl-option
                          [value]="group.get('load')?.value?.id"
                          [label]="group.get('load')?.value?.nameTranslated"
                          [loadType]="true"
                          class="loadOption"
                          [ngClass]="{'disabledOption': isDisabled}"
                          >
                          <gl-checkbox
                            [formControl]="group.get('isChecked')"
                            [defaultChecked]="group.get('isChecked')?.value"
                            class="loadCheckbox"
                            [ngClass]="{'disabledInput': isDisabled}"
                            >
                            <div class="groupColor"
                            [ngStyle]="{ 'background-color': getColor(group?.get('load')?.value) }"></div>
                            {{ group.get('load')?.value?.nameTranslated }}
                          </gl-checkbox>
                          <input type="number" min="0" class="loadQty" [formControl]="group.get('numberOfLoads')"
                            [ngClass]="{'disabledInput': isDisabled}"
                            (click)="preventClick($event)" />
                        </gl-option>
                      }
                    </gl-select>
                  </ng-container>
                </div>
                <div class="containerRow">
                  <ng-container formGroupName="timespans">
                    <gl-input-container class="input">
                      <input
                        type="datetime-local"
                        normal-input
                        placeholder="begin_date"
                        formControlName="begin"
                        [min]="today"
                        />
                    </gl-input-container>
                    <gl-input-container class="input">
                      <input
                        type="datetime-local"
                        normal-input
                        placeholder="end_date"
                        formControlName="end"
                        [min]="today"
                        />
                    </gl-input-container>
                  </ng-container>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="buttons right submit">
    <button type="submit" normal-outline-button>
      {{ 'publish' | translate }}
    </button>
  </div>
</form>
